import unpackToken from './unpack-token';

export default function getTokenExpDate(token: string): string {
  const { exp } = unpackToken(token);
  return new Date(exp * 1000).toISOString();
}
